import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {Component, Inject, OnInit} from "@angular/core";

@Component({
    selector: 'dp-connect-notification',
    templateUrl: './notification.html',

})
export class NotificationComponent implements OnInit {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
        console.log(data);
    }

    ngOnInit() {}

    get isWarning() : boolean{
        return (this.data && this.data.notificationType && this.data.notificationType == 'warn');
    }

    get isError() : boolean {
        return (this.data && this.data.notificationType && this.data.notificationType == 'error');
    }


    closeNotifier() {
        this.data.notifier.dismiss();
    }

}